module.exports = __webpack_public_path__ + "static/goals_rocket_plans_art@2x-caa226256a40f9820dce3baa9a62aed3.png";